import i18n from '@/libs/i18n';
import { extend } from 'vee-validate';
import isURL from "validator/lib/isURL";

// Rule for agent name validation
extend('agent_name', {
  validate: value => {
    const pattern = /^[a-zA-Z][a-zA-Z0-9_]*$/;
    return pattern.test(value);
  },
  // message: 'Name must start with a letter and contain only letters, numbers, and underscores'
  message: i18n.t('validations.agentName')
});

// Rule for parameter key validation (valid JSON property name)
extend('param_key', {
  validate: value => {
    // Valid JSON property names can include letters, numbers, and underscores
    // They must start with a letter or underscore
    const pattern = /^[a-zA-Z_][a-zA-Z0-9_]*$/;
    return pattern.test(value);
  },
  message: i18n.t('validations.paramKey')
});

// extend('required', {
//   validate(value) {
//     return {
//       required: true,
//       valid: ['', null, undefined].indexOf(value) === -1
//     };
//   },
//   message: i18n.t('validations.requiredValidate')
// });

extend("url", {
  validate(value) {
    if (value) {
      return isURL(value, { require_tld: false });
    }

    return false;
  },
  message: function (field) {
    return i18n.t(`validations.messages.url`, {
      _field_: i18n.t(field),
    });
  },
});
